const accardionData = [
    {
        id: 1,
        num: '01',
        title: 'Какой состав сока Alatoo?',
        text: 'Детокс сок Алатоо имеет очень простой состав. Это сок зеленой папайи и сок горького арбуза. В свою очередь эти два компонента включают в себя множество полезных ферментов, микроэлементов и витаминов, таких как органические кислоты, витамин с, витамин b1, витамин d, а также фермент папаин.'
    },
    {
        id: 2,
        num: '02',
        title: 'Сколько стоит Алатоо и сколько стоит доставка?',
        text: 'Детокс сок Алатоо имеет очень простой состав. Это сок зеленой папайи и сок горького арбуза. В свою очередь эти два компонента включают в себя множество полезных ферментов, микроэлементов и витаминов, таких как органические кислоты, витамин с, витамин b1, витамин d, а также фермент папаин.'
    },
    {
        id: 3,
        num: '03',
        title: 'Здравствуйте, аллергия часто на этот сок?',
        text: 'Детокс сок Алатоо имеет очень простой состав. Это сок зеленой папайи и сок горького арбуза. В свою очередь эти два компонента включают в себя множество полезных ферментов, микроэлементов и витаминов, таких как органические кислоты, витамин с, витамин b1, витамин d, а также фермент папаин.'
    },
    {
        id: 4,
        num: '04',
        title: 'Эффективен ли сок Алатоо при часто рецидивирующем герпесе?',
        text: 'Детокс сок Алатоо имеет очень простой состав. Это сок зеленой папайи и сок горького арбуза. В свою очередь эти два компонента включают в себя множество полезных ферментов, микроэлементов и витаминов, таких как органические кислоты, витамин с, витамин b1, витамин d, а также фермент папаин.'
    },
    {
        id: 5,
        num: '05',
        title: 'Здравствуйте, можно ли принимать при полипе в жёлчном пузыре?',
        text: 'Детокс сок Алатоо имеет очень простой состав. Это сок зеленой папайи и сок горького арбуза. В свою очередь эти два компонента включают в себя множество полезных ферментов, микроэлементов и витаминов, таких как органические кислоты, витамин с, витамин b1, витамин d, а также фермент папаин.'
    },
    {
        id: 6,
        num: '06',
        title: 'Здравствуйте, можно ли принимать при полипе в жёлчном пузыре?',
        text: 'Детокс сок Алатоо имеет очень простой состав. Это сок зеленой папайи и сок горького арбуза. В свою очередь эти два компонента включают в себя множество полезных ферментов, микроэлементов и витаминов, таких как органические кислоты, витамин с, витамин b1, витамин d, а также фермент папаин.'
    },
    {
        id: 7,
        num: '07',
        title: 'Здравствуйте, можно ли принимать при полипе в жёлчном пузыре?',
        text: 'Детокс сок Алатоо имеет очень простой состав. Это сок зеленой папайи и сок горького арбуза. В свою очередь эти два компонента включают в себя множество полезных ферментов, микроэлементов и витаминов, таких как органические кислоты, витамин с, витамин b1, витамин d, а также фермент папаин.'
    },
]

export default accardionData;